import { IconButton, InputStepper, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';
import { treasuryMaximumQuantityItem, treasuryMaximumStepperValueItem } from '../../../../../utils';

import { AddedProductResponsiveItemDirectTreasuryProps } from '.';

export const AddedProductItemDirectTreasuryMobile: React.FC<
  AddedProductResponsiveItemDirectTreasuryProps
> = (props) => {
  const {
    data,
    amountItem,
    handleChangeAmountItem,
    inputIsFocused,
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible,
    onRemoveProduct,
    inputIsDisabled,
  } = props;
  return (
    <VStack w="full">
      <VStack w="full">
        <TableContentItemText variant="bold" fontSize={Typography['fontsize.lg']}>
          {data.titleName || messageError}
        </TableContentItemText>
      </VStack>
      <VStack space={Spacing['stack.nano']} w={'full'}>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Rentabilidade</TableContentItemText>
          <TableContentItemText>{`${data.rateIncome} + ${Utils.Mask.Percentage(
            data.purchaseRate
          )}`}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Risco</TableContentItemText>
          <RiskRating
            currentRiskRating={Number(data.productRisk?.risk || 0)}
            tooltip={data?.productRisk?.formatRisk || messageError}
          />
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Vencimento</TableContentItemText>
          <TableContentItemText>
            {Utils.Mask.DateFormat((data.maturityDate || '') as Date, 'dd/MM/yyyy')}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <TableContentItemText>Juros</TableContentItemText>
          <TableContentItemText>{data.periodicityRate || messageError}</TableContentItemText>
        </TableContentItemColumn>
      </VStack>
      <VStack w={'full'} space={Spacing['inline.quarck']}>
        <TableContentItemText>Quantidade</TableContentItemText>
        <InputStepper
          disabled={inputIsDisabled}
          isDisabled={inputIsDisabled}
          stepperValue={treasuryMaximumStepperValueItem}
          max={treasuryMaximumQuantityItem}
          min={data.minimumStepQuantity || 0.01}
          name="treasury-amount-order-input"
          testId="treasury-amount-order-input"
          keyboardType="numeric"
          fontSize={Typography['fontsize.md']}
          defaultValue={amountItem}
          onChange={handleChangeAmountItem}
          showErrorMessage={false}
        />
      </VStack>
      <VStack w={'full'} space={Spacing['inline.quarck']}>
        <TableContentItemText>A partir de</TableContentItemText>
        <HStack w={'full'} alignContent={'center'} space={Spacing['stack.xxxs']}>
          <VStack flex={1}>
            <InputMoney {...inputMoneyDataProps} />
            {messageAdjustUnitPriceIsVisible && !inputIsFocused && (
              <TableContentItemText fontSize={Typography['fontsize.xs']} color="neutral.light">
                Ajustado por preço unitário
              </TableContentItemText>
            )}
          </VStack>
          <IconButton
            testId="icon-button"
            borderRadius={BoxRadius.sm}
            onPress={onRemoveProduct}
            icon="Trash"
            p={0}
            iconColor={Color['feedback.error.default']}
            iconSize="xs"
          />
        </HStack>
      </VStack>
    </VStack>
  );
};
